module.exports = __webpack_public_path__ + "static/media/fr.39659f14.svg";